<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="名称">
          <el-input
            style="width: 220px"
            v-model.trim="queryForm.knowledgeName"
            clearable
            placeholder="请输入知识库名称"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            style="width: 220px"
            v-model.trim="queryForm.knowledgeTitle"
            clearable
            placeholder="请输入知识库标题"
            @keyup.enter.native="search"
          />
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        row-key="knowledgeId"
        default-expand-all
        :tree-props="{ children: 'children' }"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column
          prop="knowledgeName"
          label="名称"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          prop="knowledgeTitle"
          label="标题"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          prop="sort"
          label="排序"
          width="90"
        />
        <el-table-column
          align="center"
          prop="updateTime"
          label="更新时间"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="isRoot(scope.row)"
              plain
              round
              size="small"
              type="success"
              @click="openForm('add', { parentId: scope.row.knowledgeId })"
              >新增子级</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openForm('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <KnowledgeForm ref="formRef" @success="search" />
  </div>
</template>

<script>
import { getKnowledgeTree, deleteKnowledge } from "@/api/content/knowledge";
import KnowledgeForm from "./KnowledgeForm.vue";

export default {
  name: "Knowledge",
  components: { KnowledgeForm },
  data() {
    return {
      queryForm: {
        knowledgeName: "",
        knowledgeTitle: ""
      },
      listData: [],
      fullTreeData: [],
      allParentOptions: [],
      loading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    isRoot(row) {
      return !row.parentId || Number(row.parentId) === 0;
    },
    resetSelect() {
      this.queryForm = {
        knowledgeName: "",
        knowledgeTitle: ""
      };
      this.search();
    },
    normalizeTree(result) {
      const data = result && result.data;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.rows)) return data.rows;
      return [];
    },
    /** 上级节点：全部一级分类（根节点在表单内固定 option） */
    collectFirstLevelOptions(list, excludeId) {
      const options = [];
      const seen = {};
      const walk = nodes => {
        (nodes || []).forEach(item => {
          if (!item) return;
          if (
            excludeId != null &&
            String(item.knowledgeId) === String(excludeId)
          ) {
            return;
          }
          const isFirstLevel =
            item.parentId == null ||
            item.parentId === "" ||
            Number(item.parentId) === 0;
          if (isFirstLevel) {
            const key = String(item.knowledgeId);
            if (!seen[key]) {
              seen[key] = true;
              options.push({
                knowledgeId: item.knowledgeId,
                knowledgeName: item.knowledgeName || "-"
              });
            }
          }
          if (Array.isArray(item.children) && item.children.length) {
            walk(item.children);
          }
        });
      };
      walk(list);
      return options;
    },
    async loadAllParentOptions() {
      try {
        const result = await getKnowledgeTree({});
        this.fullTreeData = this.normalizeTree(result);
        this.allParentOptions = this.collectFirstLevelOptions(this.fullTreeData);
      } catch (e) {
        this.fullTreeData = [];
        this.allParentOptions = [];
      }
    },
    async search() {
      this.loading = true;
      try {
        const params = {};
        if (this.queryForm.knowledgeName) {
          params.knowledgeName = this.queryForm.knowledgeName;
        }
        if (this.queryForm.knowledgeTitle) {
          params.knowledgeTitle = this.queryForm.knowledgeTitle;
        }
        const [result] = await Promise.all([
          getKnowledgeTree(params),
          this.loadAllParentOptions()
        ]);
        this.listData = this.normalizeTree(result);
      } catch (e) {
        this.listData = [];
      } finally {
        this.loading = false;
      }
    },
    openForm(type, row = {}) {
      let parentOptions = this.allParentOptions;
      if (type === "edit" && row.knowledgeId != null) {
        parentOptions = this.collectFirstLevelOptions(
          this.fullTreeData,
          row.knowledgeId
        );
      }
      const payload = { ...(row || {}) };
      if (type === "add" && row && row.parentId != null) {
        payload.parentLocked = true;
      }
      this.$refs.formRef.open(type, payload, parentOptions);
    },
    deleteInfo(row) {
      const hasChildren =
        Array.isArray(row.children) && row.children.length > 0;
      const tip = hasChildren
        ? "将同时删除该节点下的子节点，确定继续吗？"
        : "确定要删除该知识库吗？";
      this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteKnowledge(row.knowledgeId);
            this.$message.success("删除成功");
            this.search();
          } catch (e) {}
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Knowledge/index.vue